export const customSortByLatestVersion = (rowA, rowB, id) => {
    const sourceA = rowA.original.latestVersion || rowA.original.comparedVersion;
    const sourceB = rowB.original.latestVersion || rowB.original.comparedVersion;
    if (sourceA && sourceB) {
        if (sourceA[id] === null) return 1;
        if (sourceB[id] === null) return -1;
        return sourceB[id] - sourceA[id];
    }

    return 0;
};
export const customSortByChangeMap = (rowA, rowB, id) => {
    if (rowA.original.changeMap && rowB.original.changeMap) {
        if (rowA.original.changeMap[id] === null) return 1;
        if (rowB.original.changeMap[id] === null) return -1;
        return rowB.original.changeMap[id] - rowA.original.changeMap[id];
    }

    return 0;
};
export const customSortWithNullV8 = (rowA, rowB, id) => {
    const valueA = rowA.getValue(id);
    const valueB = rowB.getValue(id);
    if (valueA === null) return 1;
    if (valueB === null) return -1;
    return valueA - valueB;
};
export const customSortWithNull = (rowA, rowB, id) => {
    const valueA = rowA.values[id];
    const valueB = rowB.values[id];
    if (valueA === null) return 1;
    if (valueB === null) return -1;
    return valueA - valueB;
};
export const customCaseSensitiveSort = (rowA, rowB, id) => {
    const valueA = rowA.values[id];
    const valueB = rowB.values[id];
    if (valueA.toLowerCase() < valueB.toLowerCase()) return -1;
    if (valueA.toLowerCase() > valueB.toLowerCase()) return 1;
    return 0;
};

export const serializeColumnsVisibility = ({ columns, hiddenColumns }) => {
    return columns.reduce((obj, item) => {
        return {
            ...obj,
            [item.id]: !hiddenColumns.includes(item.id),
        };
    }, {});
};
